import { GaussianBlurBackgroundProcessor, VirtualBackgroundProcessor } from "@twilio/video-processors";
import { getLocalVideoTrack, getLocalVideoTrackForCallSetting } from "../Twilio/Room/roomService";
import { ADD_PROCESSOR_OPTIONS, DEFAULT_PARAMS_VB, PROCESSOR_OPTIONS, VIRTUAL_BACKGROUND } from "../../constants/VirtualBackgroundConstant";
import { LogFirebase } from "../../services/firestore";

let gaussianBlurProcessor = null;
let virtualBackground = null;
export const applyVirtualBackgroundEffect = async (bg, imageUrl = null) => {
    const localVideoTrack = getLocalVideoTrack();
    const localVideoTrackForCallSetting = getLocalVideoTrackForCallSetting();

    const finalLocalVideoTrack = localVideoTrackForCallSetting || localVideoTrack;
    LogFirebase("VirtualBackground", "in_applyVirtualBackgroundEffect_func", "");
    if (!finalLocalVideoTrack) return;
    LogFirebase("VirtualBackground", "track_is_available_in_applyVirtualBackground_func", {
        track_readyState: finalLocalVideoTrack?.mediaStreamTrack?.readyState,
    });
    if (bg === VIRTUAL_BACKGROUND.NONE_EFFECT_ID) {
        LogFirebase("VirtualBackground", "in_none_effect_condition", { track_readyState: finalLocalVideoTrack?.mediaStreamTrack?.readyState });
        setVirtualBackgroundProcessor(finalLocalVideoTrack, null);
    } else if (bg === VIRTUAL_BACKGROUND.BLUR_EFFECT_ID) {
        if (!gaussianBlurProcessor) {
            LogFirebase("VirtualBackground", "gaussianBlurProcessor_load", "");
            gaussianBlurProcessor = new GaussianBlurBackgroundProcessor({
                blurFilterRadius: Number(DEFAULT_PARAMS_VB.blurFilterRadius),
                ...PROCESSOR_OPTIONS,
            });
            await gaussianBlurProcessor.loadModel();
        }
        LogFirebase("VirtualBackground", "in_blur_effect_condition", { track_readyState: finalLocalVideoTrack?.mediaStreamTrack?.readyState });
        setVirtualBackgroundProcessor(finalLocalVideoTrack, gaussianBlurProcessor);
    } else {
        const bgImage = await loadVirtualBackgroundImage(bg, imageUrl);
        if (!virtualBackground) {
            LogFirebase("VirtualBackground", "VirtualBackgroundProcessor_load", "");
            virtualBackground = new VirtualBackgroundProcessor({
                backgroundImage: bgImage,
                fitType: DEFAULT_PARAMS_VB.fillType, // 'contain' prevents stretching.
                ...PROCESSOR_OPTIONS,
            });
            await virtualBackground.loadModel();
        } else {
            LogFirebase("VirtualBackground", "VirtualBackgroundProcessor_already_loaded", "");
            virtualBackground.backgroundImage = bgImage;
        }
        LogFirebase("VirtualBackground", "in_VB_image_effect", { track_readyState: finalLocalVideoTrack?.mediaStreamTrack?.readyState });
        setVirtualBackgroundProcessor(finalLocalVideoTrack, virtualBackground);
    }
};

const loadVirtualBackgroundImage = (name, imageUrl = null) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error(`Failed to load image: ${name}`));
        img.src = name === VIRTUAL_BACKGROUND.LOCAL_IMAGE_ID ? imageUrl : `${process.env.PUBLIC_URL}/images/${name}.jpg`;
    });
};

const setVirtualBackgroundProcessor = (track, processor) => {
    if (track.processor === processor) return;
    if (track.processor) track.removeProcessor(track.processor);
    if (processor) track.addProcessor(processor, ADD_PROCESSOR_OPTIONS);
};
